<div *ngIf="!hasError" id="adf34435463444" class="userPerformanceChart"></div>
<div *ngIf="hasError" class="error">
    <ion-text color="danger">{{ errorMessage | json }}</ion-text>
</div>
